import { Text, Title } from "@src/appV2/redesign/system/ui-components";

export function UnknownErrorContent(): JSX.Element {
  return (
    <>
      <Title variant="h2" component="h1">
        NFC error
      </Title>
      <Text bold>Something went wrong, please try again.</Text>
    </>
  );
}
